import AgingStatisticsReducer from './AgingStatisticsReducer';

export default from './AgingStatisticsContainer';
export const AgingStatisticsReducers = {
  AgingStatisticsReducer,
};
